import type { ComponentType } from 'react'
import type { NectarTask } from '../api/models'
import { AudioRecordingTask } from './audio-recording/AudioRecordingTask'

export type TaskRendererProps = {
  task: NectarTask
  projectId: string
  onSubmitted: (taskId: string) => void
}

export const TASK_TYPE_COMPONENTS = new Map<string, ComponentType<TaskRendererProps>>([
  ['audio-recording', AudioRecordingTask]
])
